import { atom } from 'recoil';

export const ShowLocationControlState = atom({
    key: 'ShowLocationControlState', 
    default: true, 
});